import { Icon } from "../icons";
import { Link } from "./link";

/** Props Interface */
interface PhoneProps {
	children: string;
	isNullable?: boolean;
}

export function Phone({ children, isNullable }: PhoneProps) {
	/** Guard */
	if (children === "--" || !children) {
		if (isNullable) return null;
		return children;
	}

	/** Computed */
	const href = `tel:${children}`;

	/** Render */
	return (
		<div className="flex flex-row items-center gap-1">
			<Link href={href}>
				<span className="inline-flex translate-y-[2px] mr-1 opacity-50">
					<Icon name="Phone" />
				</span>
				{children}
			</Link>
		</div>
	);
}
